<template>
  <div class="admin-content">
    <div class="content-main">
      <el-form ref="form" label-position="top" size="small">
        <div class="sources-container" v-loading="flagLoading.getSongs || flagLoading.save">
          <div class="sources-item" v-for="(song) in songs" :key="song._id">
            <div class="source-header">
              <div class="header-info">
                <div class="info-left" @click="toggleSongSelect(song._id)">
                  <div class="info-icon">
                    <el-icon v-show="!songSelect.includes(song._id)"><arrow-down-bold /></el-icon>
                    <el-icon v-show="songSelect.includes(song._id)"><arrow-up-bold /></el-icon>
                  </div>
                  <div class="info-title">
                    <span class="title-song">{{ song.name }}</span>
                    <span class="title-writer">{{ song.song_writer }}</span>
                  </div>
                </div>
                <div class="info-switch">
                  <el-switch v-model="songsPublished[song._id]" active-color="#A5C2CB" @change="updateSong(song)" />
                </div>
                <div class="info-order">
                  <el-select
                    v-model="song.order" style="width: 60px;" placeholder=" " size="mini"
                    @change="(val) => {changeSongOrder(val, song)}"
                  >
                    <el-option v-for="num in songs.length"  :key="num" :label="num" :value="num"></el-option>
                  </el-select>
                </div>
                <div class="info-action">
                  <el-icon class="info-icon" :size="20" @click="editSong(song)"><edit /></el-icon>
                </div>
              </div>
              <div class="header-titles">
                <div class="title-item item-source">
                  <span>Source</span>
                </div>
                <div class="title-item item-performer">
                  <span>Performer</span>
                </div>
                <div class="title-item item-active">
                  <span>Active</span>
                </div>
                <div class="title-item item-order">
                  <span>Order</span>
                  <el-icon class="text-icon" :size="16" @click="orderInstruments(song._id)"><bottom /></el-icon>
                </div>
                <div class="title-item item-action">
                  <span>Action</span>
                </div>
              </div>
            </div>
            <div class="source-content" v-show="songSelect.includes(song._id)">
              <div class="instrument-list">
                <div class="instrument-item" v-for="(instrument, instrumentIndex) in instruments[song._id]"  :key="instrument._id">
                  <div class="item-text text-source">
                    <span>{{ instrument.name }}</span>
                  </div>
                  <div class="item-text text-performer">
                    <span>{{ instrument.performer_name }}</span>
                  </div>
                  <div class="item-text text-active">
                    <div
                      :class="['ca-checkbox', instrument.is_published === 1 ? 'active': 'inactive']"
                      @click="toggleInstrumentActive(song._id, instrumentIndex, instrument.is_published)"
                    ></div>
                  </div>
                  <div class="item-text text-order">
                    <el-select
                      v-model="instrument.order" style="width: 60px;" placeholder=" " size="mini"
                      @change="((val) => {changeOrderInstrument(val, instrument)})"
                    >
                      <el-option v-for="num in instruments[song._id].length"  :key="num" :label="num" :value="num"></el-option>
                    </el-select>
                  </div>
                  <div class="item-text text-action">
                    <el-icon class="text-icon" :size="20" @click="editInstrument(instrument)"><edit /></el-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <ModalSong
      role="admin" :flagVisible="flagVisible.modalSong" @closeModal="flagVisible.modalSong = false"
      :actionItem="actionItems.song" @reloadData="reloadData"
    />
    <ModalInstrument
      role="admin" :flagVisible="flagVisible.modalInstrument" @closeModal="flagVisible.modalInstrument = false"
      :actionItem="actionItems.instrument" @reloadInstruments="reloadInstruments"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import { ArrowUpBold, ArrowDownBold, Bottom, Edit } from '@element-plus/icons'
import ModalSong from '@/components/modals/Song.vue'
import ModalInstrument from '@/components/modals/Instrument.vue'
import _ from 'lodash'
export default {
  name: 'TabSources',
  props: {
  },
  emits: [],
  components: {
    ArrowUpBold,
    ArrowDownBold,
    Bottom,
    Edit,
    ModalSong,
    ModalInstrument
  },
  data () {
    const flagLoading = reactive({
      getSongs: false,
      save: false
    })
    const flagVisible = reactive({
      modalSong: false,
      modalInstrument: false
    })
    const actionItems = reactive({
      song: {},
      instrument: {}
    })
    return {
      songs: [],
      songsPublished: {},
      songSelect: [],
      instruments: {},
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
    this.getSongs()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getSongs: function () {
      this.flagLoading.getSongs = true
      const url = '/api/v1/atk_player/admin/songs?page_num=1&page_size=1000&is_atk=true&is_deleted=false'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.songs = _.sortBy(res.data.list, ['order'])
          res.data.list.map(song => {
            that.getInstruments(song._id)
            that.songsPublished[song._id] = song.is_published === 1
          })
        } else {
          console.error('getSongs', res.msg)
        }
        that.flagLoading.getSongs = false
      }).catch(function (err) {
        console.error('getSongs', err)
        that.flagLoading.getSongs = false
      })
    },
    getInstruments: function (songId) {
      this.flagLoading.getSongs = true
      const url = `/api/v1/atk_player/admin/instruments?song_id=${songId}&page_num=1&page_size=1000&is_deleted=false&sort=order`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.instruments[songId] = res.data.list
        } else {
          console.error('getInstruments', res.msg)
        }
        that.flagLoading.getSongs = false
      }).catch(function (err) {
        console.error('getInstruments', err)
        that.flagLoading.getSongs = false
      })
    },
    updateSong: function (song) {
      // if (this.flagLoading.save) return
      this.flagLoading.save = true
      const url = `/api/v1/atk_player/admin/songs/${song._id}`
      const that = this
      song.is_published = this.songsPublished[song._id] ? 1 : 0
      this.$service.put(url, song).then(function (res) {
        if (res.code !== 200) {
          console.error('updateSong', res.msg)
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateSong', err)
        that.flagLoading.save = false
      })
    },
    updateInstrument: function (instrument) {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player/admin/instruments/${instrument._id}`
      const that = this
      this.$service.put(url, instrument).then(function (res) {
        if (res.code !== 200) {
          console.error('updateInstrument', res.msg)
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateInstrument', err)
        that.flagLoading.save = false
      })
    },
    toggleSongSelect: function (val) {
      if (this.songSelect.includes(val)) {
        this.songSelect = _.difference(this.songSelect, [val])
      } else {
        this.songSelect.push(val)
      }
    },
    orderInstruments: function (songId) {
      this.instruments[songId] = _.sortBy(this.instruments[songId], ['order'])
    },
    toggleInstrumentActive: function (songId, instrumentIndex, published) {
      this.instruments[songId][instrumentIndex].is_published = published === 1 ? 0 : 1
      this.updateInstrument(this.instruments[songId][instrumentIndex])
    },
    editSong: function (song) {
      const actionSong = this.actionItems.song
      if (actionSong._id !== song._id) {
        this.actionItems.song = { ...song }
      }
      this.flagVisible.modalSong = true
    },
    editInstrument: function (instrument) {
      const actionInstrument = this.actionItems.instrument
      if (actionInstrument._id !== instrument._id) {
        this.actionItems.instrument = { ...instrument }
      }
      this.flagVisible.modalInstrument = true
    },
    reloadData: function () {
      this.actionItems.song = {
        _id: '',
        name: ''
      }
      this.actionItems.instrument = { _id: '', name: '' }
      this.getSongs()
    },
    reloadInstruments: function (songId) {
      this.actionItems.instrument = { _id: '', name: '' }
      this.getInstruments(songId)
    },
    changeOrderInstrument: function (val, instrument) {
      this.updateInstrument(instrument)
      const instrumentIndex = _.findIndex(this.instruments[instrument.song_id], (item) => {
        return item._id === instrument._id
      })
      if (val < instrumentIndex + 1) {
        this.instruments[instrument.song_id].map(item => {
          if ((item.order === val && item._id !== instrument._id) || (item.order > val && item.order < instrumentIndex + 1)) {
            item.order += 1
            this.updateInstrument(item)
          }
        })
      } else if (val > instrumentIndex + 1) {
        this.instruments[instrument.song_id].map(item => {
          if ((item.order === val && item._id !== instrument._id) || (item.order > instrumentIndex + 1 && item.order < val)) {
            item.order -= 1
            this.updateInstrument(item)
          }
        })
      }
      this.instruments[instrument.song_id] = _.sortBy(this.instruments[instrument.song_id], ['order'])
    },
    changeSongOrder: function (val, song) {
      this.updateSong(song)
      const songIndex = _.findIndex(this.songs, item => {
        return item._id === song._id
      })
      if (val < songIndex + 1) {
        this.songs.map(item => {
          if ((item.order === val && item._id !== song._id) || (item.order > val && item.order < songIndex + 1)) {
            item.order += 1
            this.updateSong(item)
          }
        })
      } else if (val > songIndex + 1) {
        this.songs.map(item => {
          if ((item.order === val && item._id !== song._id) || (item.order > songIndex + 1 && item.order < val)) {
            item.order -= 1
            this.updateSong(item)
          }
        })
      }
      this.songs = _.sortBy(this.songs, ['order'])
    }
  }
}
</script>
<style lang="scss" scoped>
.sources-container {
  width: 80%;
  .sources-item {
    margin-bottom: 32px;
    .source-header {
      background-color: #DBE7EA;
      border-radius: 8px;
      padding: 12px 16px;
      font-size: 16px;
      .header-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        .info-left {
          width: 65%;
          display: flex;
          align-items: center;
          cursor: pointer;
          .info-icon {
            margin-right: 12px;
          }
          .info-title {
            .title-song {
              font-size: 18px;
              font-weight: bold;
              margin-right: 12px;
            }
            .title-writer {
              font-size: 14px;
              font-weight: 300;
            }
          }
        }
        .info-switch {
          width: 15%;
        }
        .info-order {
          width: 10%;
        }
        .info-action {
          width: 10%;
          display: flex;
          flex-direction: row-reverse;
          .info-icon {
            cursor: pointer;
          }
        }
      }
      .header-titles {
        display: flex;
        .title-item {
          font-weight: bold;
          display: flex;
          align-items: center;
          span {
            margin-right: 5px;
          }
          .text-icon {
            cursor: pointer;
          }
          &.item-source { width: 35%; }
          &.item-performer { width: 30%; }
          &.item-active { width: 15%; }
          &.item-order { width: 10%; }
          &.item-action {
            width: 10%;
            display: flex;
            flex-direction: row-reverse;
          }
        }
      }
    }
    .source-content {
      .instrument-list {
        padding: 0 16px;
        .instrument-item {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: solid 1px #F2F2F2;
          .item-text {
            &.text-source { width: 35%; }
            &.text-performer { width: 30%; }
            &.text-active { width: 15%; }
            &.text-order { width: 10%; }
            &.text-action {
              width: 10%;
              display: flex;
              flex-direction: row-reverse;
              .text-icon {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>
